import ImageWrapper from "@/components/ImageWrapper";
import SplitAmount from "@/utils/offers/SplitAmount";
import { Box } from "@dxp-feed/ui/Box";
import { Text } from "@dxp-feed/ui/Text";
import React from "react";

export default function OffersCardHeader({
  headerOffers,
  styleClass,
  showTerms,
}: any) {
  const headerOfferType = headerOffers?.offerType?.toString();

  // console.log("headerOffers", headerOffers);
  return (
    <>
      {headerOffers.offerType === "11" && (
        //  offer type : Points
        <Box
          as="div"
          className={`offerstop bg-brandBlack flex flex-row items-center justify-center gap-1  
            ${styleClass ? "rounded-full w-[200px]" : showTerms ? "rounded-t-[0px] !py-[14px]" : "rounded-t-[12px]"} min-h-[32px]`}
        >
          <ImageWrapper
            src="/home/scene-plus.svg"
            width={16}
            height={16}
            className=""
            alt="scene plus image"
          />
          {headerOffers?.points && (
            <>
              <Text
                as="span"
                className="count text-brandWhite font-bold xs:text-body text-sm"
              >
                {headerOffers?.points}
              </Text>
              <Text
                as="span"
                className="bg-purple300 xs:text-body text-sm inline-flex text-brandWhite px-[3.5px] font-bold items-center rounded-tl-[5px] max-h-[18px] rounded-br-[5px]"
              >
                PTS
              </Text>
            </>
          )}
        </Box>
      )}
      {headerOffers.offerType === "12" && (
        // offer type : Special retail
        <Box
          as="div"
          className={`px-[0px] gap-[5px] mb-[0px] lg:mb-[0px] bg-brandBlack flex text-center items-center justify-center 
            ${styleClass ? "rounded-full w-[200px]" : showTerms ? "rounded-t-[0px] !py-[14px]" : "rounded-t-[12px]"} min-h-[32px] py-[4px]`}
        >
          <Text
            as="span"
            className="text-brandWhite inline-flex font-bold xs:text-body text-sm"
          >
            {headerOffers?.offerIconText1 && (
              <>
                <SplitAmount amount={headerOffers?.offerIconText1} />
                {headerOffers?.offerIconText2}
              </>
            )}
          </Text>
        </Box>
      )}
      {headerOffers.offerType === "13" && (
        //  offer type : % off
        <Box
          as="div"
          className={`px-[0px] gap-1 mb-[0px] lg:mb-[0px] bg-brandBlack flex text-center items-center justify-center 
            ${styleClass ? "rounded-full w-[200px]" : showTerms ? "rounded-t-[0px] !py-[14px]" : "rounded-t-[12px]"} min-h-[32px] py-[4px]`}
        >
          {headerOffers?.offerIconText1 && (
            <>
              <Text
                as="span"
                className="bg-yellow150 text-brandBlack inline-flex xs:text-body text-sm px-[3px] rounded-tl-[5px] rounded-br-[5px] h-[20px] max-h-[18px] items-center font-bold"
              >
                SAVE
              </Text>
              <Text
                as="span"
                className="text-brandWhite inline-flex font-bold xs:text-body text-sm"
              >
                {headerOffers?.offerIconText1}
                {/* <Text className="text-xxs top-[5px] mx-[2px]">
                  %
                </Text> */}
                <Text as="span" className="ml-[1px]">
                  %
                </Text>
              </Text>
            </>
          )}
        </Box>
      )}

      {headerOffers.offerType === "14" && (
        // Offer type: $ off
        <Box
          as="div"
          className={`px-[0px] gap-1 mb-[0px] lg:mb-[0px] bg-brandBlack flex text-center items-center justify-center 
            ${styleClass ? "rounded-full w-[200px]" : showTerms ? "rounded-t-[0px] !py-[14px]" : "rounded-t-[12px]"} min-h-[32px] py-[4px]`}
        >
          {headerOffers?.offerIconText1 && (
            <>
              <Text
                as="span"
                className="bg-yellow150 text-brandBlack inline-flex xs:text-body text-sm px-[3px] rounded-tl-[5px] rounded-br-[5px] h-[20px] max-h-[18px] items-center font-bold"
              >
                SAVE
              </Text>
              <Text
                as="span"
                className="text-brandWhite inline-flex font-bold xs:text-body text-sm"
              >
                <SplitAmount amount={headerOffers?.offerIconText1} />
              </Text>
            </>
          )}
        </Box>
      )}

      {headerOffers.offerType === "15" && (
        // offer type : BOGO Free
        <Box
          as="div"
          className={`px-[0px] gap-1 mb-[0px] lg:mb-[0px] bg-brandBlack flex text-center items-center justify-center 
            ${styleClass ? "rounded-full w-[200px]" : showTerms ? "rounded-t-[0px] !py-[14px]" : "rounded-t-[12px]"} min-h-[32px] py-[4px]`}
        >
          {headerOffers?.offerIconText1 &&
            headerOffers?.offerIconText2 &&
            headerOffers?.offerIconText3 && (
              <>
                <Text
                  as="span"
                  className="bg-yellow150 text-brandBlack inline-flex xs:text-body text-sm px-[6.5px] rounded-tl-[5px] rounded-br-[5px] h-[20px] max-h-[18px] items-center font-bold"
                >
                  BUY {headerOffers?.offerIconText1} GET{" "}
                  {headerOffers?.offerIconText2}
                </Text>
                <Text
                  as="span"
                  className="text-brandWhite inline-flex uppercase font-bold xs:text-body text-sm"
                >
                  {headerOffers?.offerIconText3}
                </Text>
              </>
            )}
        </Box>
      )}

      {headerOffers.offerType === "16" && (
        // offer type : BOGO $ Off
        <Box
          as="div"
          className={`px-[0px] gap-1 mb-[0px] lg:mb-[0px] bg-brandBlack flex text-center items-center justify-center  
            ${styleClass ? "rounded-full w-[200px]" : showTerms ? "rounded-t-[0px] !py-[14px]" : "rounded-t-[12px]"} min-h-[32px] py-[4px]`}
        >
          {headerOffers?.offerIconText1 &&
            headerOffers?.offerIconText2 &&
            headerOffers?.offerIconText3 && (
              <>
                <Text
                  as="span"
                  className="bg-yellow150 text-brandBlack inline-flex xs:text-body text-sm px-[6.5px] rounded-tl-[5px] rounded-br-[5px] h-[20px] max-h-[18px] items-center font-bold"
                >
                  BUY {headerOffers?.offerIconText1} GET{" "}
                  {headerOffers?.offerIconText2}
                </Text>
                <Text
                  as="span"
                  className="text-brandWhite inline-flex font-bold xs:text-body text-sm"
                >
                  <SplitAmount amount={headerOffers?.offerIconText3} />
                  {/* <Text as="sup" className="text-xxs top-0 ml-[2px] mr-[4px]">
              {headerOffers?.offerIconText3}
            </Text> */}
                  <Text as="span" className="ml-[4px]">
                    off
                  </Text>
                </Text>
              </>
            )}
        </Box>
      )}
      {headerOffers.offerType === "17" && (
        //  offer type : BOGO % off
        <Box
          as="div"
          className={`px-[0px] gap-1 mb-[0px] lg:mb-[0px] bg-brandBlack flex text-center items-center justify-center  
            ${styleClass ? "rounded-full w-[200px]" : showTerms ? "rounded-t-[0px] !py-[14px]" : "rounded-t-[12px]"} min-h-[32px] py-[4px]`}
        >
          {" "}
          {headerOffers?.offerIconText1 &&
            headerOffers?.offerIconText2 &&
            headerOffers?.offerIconText3 && (
              <>
                <Text
                  as="span"
                  className="bg-yellow150 text-brandBlack inline-flex xs:text-body text-sm px-[6.5px] rounded-tl-[5px] rounded-br-[5px] h-[20px] max-h-[18px] items-center font-bold"
                >
                  BUY {headerOffers?.offerIconText1} GET{" "}
                  {headerOffers?.offerIconText2}
                </Text>
                <Text
                  as="span"
                  className="text-brandWhite inline-flex font-bold xs:text-body text-sm"
                >
                  {headerOffers?.offerIconText3}
                  {/* <Text className="text-xxs top-[5px] mx-[2px]">
                    %
                  </Text> */}
                  <Text as="span" className="ml-[1px] mr-[2px]">
                    %
                  </Text>
                  off
                </Text>
              </>
            )}
        </Box>
      )}

      {headerOffers.offerType === "18" && (
        //  offer type : BB Points Multiplier
        <Box
          as="div"
          className={`offerstop bg-brandBlack flex flex-row items-center justify-center xs:gap-1 gap-[2px] 
            ${styleClass ? "rounded-full w-[200px]" : showTerms ? "rounded-t-[0px] !py-[14px]" : "rounded-t-[12px]"} min-h-[32px]`}
        >
          <ImageWrapper
            src="/home/scene-plus.svg"
            width={16}
            height={16}
            className=""
            alt="scene plus image"
          />
          {headerOffers?.bonusMultiplier && (
            <>
              <Text
                as="span"
                className="count text-brandWhite font-bold xs:text-body text-sm"
              >
                {headerOffers?.bonusMultiplier}X
              </Text>
              <Text
                as="span"
                className="bg-purple300 xs:text-body text-sm inline-flex text-brandWhite px-[3.5px] font-bold items-center rounded-tl-[5px] max-h-[18px] rounded-br-[5px]"
              >
                PTS
              </Text>
            </>
          )}
        </Box>
      )}
      {headerOffers.offerType === "19" && (
        //offer type : BB Points
        <Box
          as="div"
          className={`offerstop bg-brandBlack flex flex-row items-center justify-center xs:gap-1 gap-[2px] 
            ${styleClass ? "rounded-full w-[200px]" : showTerms ? "rounded-t-[0px] !py-[14px]" : "rounded-t-[12px]"} min-h-[32px]`}
        >
          <ImageWrapper
            src="/home/scene-plus.svg"
            width={16}
            height={16}
            className=""
            alt="scene plus image"
          />
          {headerOffers?.points && (
            <>
              <Text
                as="span"
                className="count text-brandWhite font-bold xs:text-body text-sm"
              >
                {headerOffers?.points}
              </Text>
              <Text
                as="span"
                className="bg-purple300 xs:text-body text-sm inline-flex text-brandWhite px-[3.5px] font-bold items-center rounded-tl-[5px] max-h-[18px] rounded-br-[5px]"
              >
                PTS
              </Text>
            </>
          )}
        </Box>
      )}
      {headerOffers.offerType === "20" && (
        //  offer type : BB % Off
        <Box
          as="div"
          className={`px-[0px] gap-1 mb-[0px] lg:mb-[0px] bg-brandBlack flex text-center items-center justify-center 
            ${styleClass ? "rounded-full w-[200px]" : showTerms ? "rounded-t-[0px] !py-[14px]" : "rounded-t-[12px]"} min-h-[32px] py-[4px]`}
        >
          {" "}
          {headerOffers?.offerIconText1 && (
            <>
              <Text
                as="span"
                className="bg-yellow150 text-brandBlack inline-flex xs:text-body text-sm px-[3px] rounded-tl-[5px] rounded-br-[5px] h-[20px] max-h-[18px] items-center font-bold"
              >
                SAVE
              </Text>{" "}
              <Text
                as="span"
                className="text-brandWhite inline-flex font-bold xs:text-body text-sm"
              >
                {headerOffers?.offerIconText1}
                {/* <Text className="text-xxs top-[5px] mx-[2px]">
                  %
                </Text> */}
                <Text as="span" className="ml-[1px]">
                  %
                </Text>
              </Text>
            </>
          )}
        </Box>
      )}
      {headerOffers.offerType === "21" && (
        // offer type : BB $ Off
        <Box
          as="div"
          className={`px-[0px] gap-1 mb-[0px] lg:mb-[0px] bg-brandBlack flex text-center items-center justify-center 
            ${styleClass ? "rounded-full w-[200px]" : showTerms ? "rounded-t-[0px] !py-[14px]" : "rounded-t-[12px]"} min-h-[32px] py-[4px]`}
        >
          {headerOffers?.offerIconText1 && (
            <>
              <Text
                as="span"
                className="bg-yellow150 text-brandBlack inline-flex xs:text-body text-sm px-[3px] rounded-tl-[5px] rounded-br-[5px] h-[20px] max-h-[18px] items-center font-bold"
              >
                SAVE
              </Text>
              <Text
                as="span"
                className="text-brandWhite inline-flex font-bold xs:text-body text-sm"
              >
                <SplitAmount amount={headerOffers?.offerIconText1} />
              </Text>
            </>
          )}
        </Box>
      )}
      {headerOffers.offerType === "22" && (
        // Offer type : Points + Special Retail
        <Box
          as="div"
          className={`offerstop bg-brandBlack flex flex-row items-center justify-center 
            ${styleClass ? "rounded-full w-[200px]" : showTerms ? "rounded-t-[0px] !py-[14px]" : "rounded-t-[12px]"} min-h-[32px]`}
        >
          {headerOffers?.points && (
            <>
              <Text className="inline-flex gap-[4px]" as="span">
                <ImageWrapper
                  src="/home/scene-plus.svg"
                  width={16}
                  height={16}
                  className=""
                  alt="scene plus image"
                />{" "}
                <Text
                  as="span"
                  className="count text-brandWhite font-bold xs:text-body text-sm"
                >
                  {headerOffers?.points}
                </Text>
                <Text
                  as="span"
                  className="bg-purple300 xs:text-body text-sm inline-flex text-brandWhite px-[3.5px] font-bold items-center rounded-tl-[5px] max-h-[18px] rounded-br-[5px]"
                >
                  PTS
                </Text>
              </Text>

              <Text
                as="span"
                className="text-brandWhite xs:text-body text-sm px-[2px]"
              >
                +
              </Text>
            </>
          )}
          {headerOffers?.offerIconText1 && (
            <>
              <Text
                as="span"
                className="text-brandWhite inline-flex font-bold xs:text-body text-sm"
              >
                <SplitAmount amount={headerOffers?.offerIconText1} />
                {/* <Text as="sup" className="text-xxs top-0 ml-[2px] mr-[4px]">
              {headerOffers?.offerIconText1}
            </Text> */}
                <Text as="span" className="ml-[4px]">
                  {headerOffers?.offerIconText2}
                </Text>
              </Text>
            </>
          )}
        </Box>
      )}

      {headerOffers.offerType === "23" && (
        // Offer type : Points + % Off
        <Box
          as="div"
          className={`offerstop bg-brandBlack flex flex-row items-center justify-center gap-[2px] 
            ${styleClass ? "rounded-full w-[200px]" : showTerms ? "rounded-t-[0px] !py-[14px]" : "rounded-t-[12px]"} min-h-[32px]`}
        >
          <ImageWrapper
            src="/home/scene-plus.svg"
            width={16}
            height={16}
            className=""
            alt="scene plus image"
          />
          {headerOffers?.points && (
            <>
              <Text
                as="span"
                className="count text-brandWhite font-bold xs:text-body text-sm"
              >
                {headerOffers?.points}
              </Text>
              <Text
                as="span"
                className="bg-purple300 xs:text-body text-sm inline-flex text-brandWhite px-[3.5px] font-bold items-center rounded-tl-[5px] max-h-[18px] rounded-br-[5px]"
              >
                PTS
              </Text>

              <Text as="span" className="text-brandWhite xs:text-body text-sm">
                +
              </Text>
            </>
          )}
          {headerOffers?.offerIconText1 && (
            <>
              <Text
                as="span"
                className="bg-yellow150 text-brandBlack inline-flex xs:text-body text-sm px-[3px] rounded-tl-[5px] rounded-br-[5px] h-[20px] max-h-[18px] items-center font-bold"
              >
                SAVE
              </Text>
              <Text
                as="span"
                className="text-brandWhite inline-flex font-bold xs:text-body text-sm"
              >
                {headerOffers?.offerIconText1}
                {/* <Text className="text-xxs top-[5px] mx-[2px]">
                  %
                </Text> */}
                <Text as="span" className="ml-[1px]">
                  %
                </Text>
              </Text>
            </>
          )}
        </Box>
      )}
      {headerOffers.offerType === "24" && (
        // Offer type : Price Discount + Points
        <Box
          as="div"
          className={`offerstop bg-brandBlack flex flex-row items-center justify-center gap-[2px] 
            ${styleClass ? "rounded-full w-[200px]" : showTerms ? "rounded-t-[0px] !py-[14px]" : "rounded-t-[12px]"} min-h-[32px]`}
        >
          <ImageWrapper
            src="/home/scene-plus.svg"
            width={16}
            height={16}
            className=""
            alt="scene plus image"
          />
          {headerOffers?.points && (
            <>
              <Text
                as="span"
                className="count text-brandWhite font-bold xs:text-body text-sm"
              >
                {headerOffers?.points}
              </Text>
              <Text
                as="span"
                className="bg-purple300 xs:text-body text-sm inline-flex text-brandWhite px-[3.5px] font-bold items-center rounded-tl-[5px] max-h-[18px] rounded-br-[5px]"
              >
                PTS
              </Text>
              <Text as="span" className="text-brandWhite xs:text-body text-sm">
                +
              </Text>
            </>
          )}
          {headerOffers?.offerIconText1 && (
            <>
              <Text
                as="span"
                className="bg-yellow150 text-brandBlack inline-flex xs:text-body text-sm px-[3px] rounded-tl-[5px] rounded-br-[5px] h-[20px] max-h-[18px] items-center font-bold"
              >
                SAVE
              </Text>
              <Text
                as="span"
                className="text-brandWhite inline-flex font-bold xs:text-body text-sm"
              >
                <SplitAmount amount={headerOffers?.offerIconText1} />
              </Text>
            </>
          )}
        </Box>
      )}

      {headerOffers.offerType === "25" && (
        // offer type : $ Off + Special Retail
        <Box
          as="div"
          className={`offerstop bg-brandBlack flex flex-row items-center justify-center gap-[2px] 
            ${styleClass ? "rounded-full w-[200px]" : showTerms ? "rounded-t-[0px] !py-[14px]" : "rounded-t-[12px]"} min-h-[32px]`}
        >
          <Text
            as="span"
            className="bg-yellow150 text-brandBlack mr-[2px] inline-flex xs:text-body text-sm px-[3px] rounded-tl-[5px] rounded-br-[5px] h-[20px] max-h-[18px] items-center font-bold"
          >
            SAVE
          </Text>
          {headerOffers?.offerIconText1 && (
            <>
              {" "}
              <Text
                as="span"
                className="text-brandWhite inline-flex font-bold xs:text-body text-sm"
              >
                <SplitAmount amount={headerOffers?.offerIconText1} />
              </Text>
              <Text
                as="span"
                className="text-brandWhite mr-[2px] font-normal xs:text-body text-sm"
              >
                |
              </Text>
            </>
          )}
          {headerOffers?.offerIconText2 && (
            <>
              <Text
                as="span"
                className="text-brandWhite inline-flex font-bold xs:text-body text-sm"
              >
                <SplitAmount amount={headerOffers?.offerIconText2} />
                <Text as="p">{headerOffers?.offerIconText3}</Text>
              </Text>
            </>
          )}
        </Box>
      )}
      {headerOffers.offerType === "26" && (
        // offer type : Points + % Off
        <Box
          as="div"
          className={`offerstop bg-brandBlack flex flex-row items-center justify-center gap-[2px] 
            ${styleClass ? "rounded-full w-[200px]" : showTerms ? "rounded-t-[0px] !py-[14px]" : "rounded-t-[12px]"} min-h-[32px]`}
        >
          {headerOffers?.offerIconText1 && (
            <>
              <Text
                as="span"
                className="bg-yellow150 text-brandBlack mr-[2px] inline-flex xs:text-body text-sm px-[3px] rounded-tl-[5px] rounded-br-[5px] h-[20px] max-h-[18px] items-center font-bold"
              >
                SAVE
              </Text>
              <Text
                as="span"
                className="text-brandWhite inline-flex font-bold xs:text-body text-sm"
              >
                {headerOffers?.offerIconText1}
                {/* <Text as="sup" className="text-xxs top-[5px] mx-[2px]">
                  %
                </Text> */}
                <Text as="span" className="ml-[1px]">
                  %
                </Text>
              </Text>

              <Text
                as="span"
                className="text-brandWhite mr-[2px] font-normal xs:text-body text-sm"
              >
                |
              </Text>
            </>
          )}
          {headerOffers?.offerIconText2 && (
            <>
              <Text
                as="span"
                className="text-brandWhite inline-flex font-bold xs:text-body text-sm"
              >
                <SplitAmount amount={headerOffers?.offerIconText2} />
              </Text>
            </>
          )}
          {headerOffers?.offerIconText3 && (
            <Text as="p">{headerOffers?.offerIconText3}</Text>
          )}
        </Box>
      )}
      {headerOffers.offerType === "27" && (
        // offer type : $ Off + Special Retail
        <Box
          as="div"
          className={`offerstop bg-brandBlack flex flex-row items-center justify-center gap-[2px] 
            ${styleClass ? "rounded-full w-[200px]" : showTerms ? "rounded-t-[0px] !py-[14px]" : "rounded-t-[12px]"} min-h-[32px]`}
        >
          {headerOffers?.offerIconText1 && (
            <>
              <Text
                as="span"
                className="text-brandWhite inline-flex font-bold xs:text-body text-sm"
              >
                {headerOffers?.offerIconText1}
              </Text>

              <Text
                as="span"
                className="text-brandWhite inline-flex font-bold xs:text-body text-sm"
              ></Text>
            </>
          )}
        </Box>
      )}
    </>
  );
}
